export default __webpack_public_path__ + "static/media/MetaMask.30289624.png";